import { Component, Input, OnInit } from '@angular/core';
import { SebbieTask } from 'src/app/models/sebbietask.model';
import { StreApperInfo } from 'src/app/models/streapper-info.model';
import { AuthService } from 'src/app/services/auth.service';
import { SebbieService } from 'src/app/services/sebbie.service';

@Component({
  selector: 'completed-tasks-widget',
  templateUrl: './completed-tasks-widget.component.html',
  styleUrl: './completed-tasks-widget.component.scss'
})
export class CompletedTasksWidgetComponent implements OnInit {
  @Input() profile: StreApperInfo;
  availableTasks: Array<SebbieTask> = [];

  constructor(
    private readonly authService: AuthService,
    private readonly sebbieService: SebbieService
  ) { }

  ngOnInit(): void {
    this.getCurrentPromotionActionTasks()
      .then(tasks => {
        this.availableTasks = tasks;
      });
  }

  isTaskCompleted(task: SebbieTask): boolean {
    return this.profile.completedSebbieTasks?.some(
      (completedTask) => completedTask.id === task.id
    );
  }

  async getCurrentPromotionActionTasks(): Promise<Array<SebbieTask>> {
    try {
      const tasks = await this.sebbieService.getCurrentPromotionActionTasks(this.authService.authorizationHeaderValue);
      return tasks;
    } catch (error: Error | any) {
      console.error('Error fetching current promotion action tasks:', error);
      return [];
    }
  }
}
